const eventTabs = (): void => {
  const classes = {
    tabActive: 'event-tabs__tab--active',
    panelActive: 'event-tabs__panel--active',
    dropdownOpen: 'event-tabs__dropdown--open',
  };

  const selectors = {
    section: '[data-event-tabs]',
    tab: '[data-event-tab]',
    panel: '[data-event-tab-panel]',
    dropdown: '[data-event-tabs-dropdown]',
    toggle: '[data-event-tabs-toggle]',
    toggleTitle: '[data-event-tabs-toggle-title]',
    toggleSubtitle: '[data-event-tabs-toggle-subtitle]',
    tabTitle: '.event-tabs__tab-title',
    tabSubtitle: '.event-tabs__tab-subtitle',
  };

  const sections = document.querySelectorAll(selectors.section);

  sections.forEach((section) => {
    const tabs = section.querySelectorAll<HTMLElement>(selectors.tab);
    const panels = section.querySelectorAll<HTMLElement>(selectors.panel);
    const dropdown = section.querySelector<HTMLElement>(selectors.dropdown);
    const toggle = section.querySelector<HTMLElement>(selectors.toggle);
    const toggleTitle = section.querySelector<HTMLElement>(selectors.toggleTitle);
    const toggleSubtitle = section.querySelector<HTMLElement>(selectors.toggleSubtitle);

    const closeDropdown = (): void => {
      if (dropdown) {
        dropdown.classList.remove(classes.dropdownOpen);
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    };

    if (dropdown && toggle) {
      toggle.addEventListener('click', () => {
        const open = dropdown.classList.toggle(classes.dropdownOpen);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target as Node)) {
          closeDropdown();
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-event-tab');

        tabs.forEach((t) => {
          t.classList.remove(classes.tabActive);
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach((p) => p.classList.remove(classes.panelActive));

        tab.classList.add(classes.tabActive);
        tab.setAttribute('aria-selected', 'true');

        const targetPanel = section.querySelector<HTMLElement>(
          `[data-event-tab-panel="${target}"]`
        );
        if (targetPanel) {
          targetPanel.classList.add(classes.panelActive);
        }

        if (toggleTitle) {
          const title = tab.querySelector<HTMLElement>(selectors.tabTitle);
          toggleTitle.textContent = title ? title.textContent : '';
        }
        if (toggleSubtitle) {
          const subtitle = tab.querySelector<HTMLElement>(selectors.tabSubtitle);
          toggleSubtitle.textContent = subtitle ? subtitle.textContent : '';
        }

        closeDropdown();
      });
    });
  });
};

export default eventTabs;
